import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialog: {
    alignSelf: 'center',
    width: '100%',
    margin: 0,
    [theme.breakpoints.up('md')]: {
      width: 1050,
      maxWidth: 1050,
      margin: '0 auto'
    }
  },
  mainContainer: {
    [theme.breakpoints.up('md')]: {
      width: 850,
      margin: '0 auto'
    }
  },
  title: {
    fontSize: '1.125rem',
    fontWeight: 600
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  formGroup: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: 0,
      justifyContent: 'space-between'
    }
  },
  input: {
    marginBottom: theme.spacing(),
    [theme.breakpoints.up('md')]: {
      width: 400
    },

    '& fieldset': {
      height: 48,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& input': {
      height: 23,
      fontWeight: 500
    },
    '& > p': {
      color: theme.palette.secondary.contrastText
    },
    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      fontSize: '1rem',
      transform: 'translate(14px, 11px) scale(1)'
    },

    '&.multiline': {
      '& textarea': {
        minHeight: '195px'
      }
    }
  },
  labelSelect: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    transform: 'translate(14px, 13px) scale(1)'
  },
  helperText: {
    marginLeft: theme.spacing(1.5)
  },
  select: {
    height: 48,
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: 400
    },

    '& > div': {
      padding: theme.spacing(1, 1.75),
      paddingTop: theme.spacing(0.5)
    },
    '& input': {
      height: 3,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& svg': {
      color: theme.palette.primary.main,
      height: 19
    }
  },
  formControl: {
    marginRight: 0
  },
  checkContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing()
  },
  adminTitle: {
    fontSize: '.875rem',
    fontWeight: 600,
    textDecoration: 'underline'
  },
  addAdminLink: {
    textDecoration: 'underline',
    fontSize: '.875rem',
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: theme.spacing()
  },
  checkLabel: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: '.875rem'
  },

  control: {
    marginRight: theme.spacing(1.5)
  },
  webCheckLabel: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    marginLeft: theme.spacing(2)
  },
  checkbox: {
    '& svg': {
      width: 20,
      height: 20,
      color: theme.palette.primary.main
    }
  },
  deleteIcon: {
    width: 20,
    height: 20
  },

  options: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: theme.spacing(1, 0),
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 450
    }
  },
  option: {
    zIndex: '2 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500,
    color: theme.palette.secondary.contrastText,
    margin: theme.spacing(1, 0),
    marginRight: theme.spacing()
  },
  infoIcon: {
    width: 23,
    height: 23
  },
  tooltip: {
    width: 300,
    backgroundColor: theme.palette.tooltip.main
  },
  adminTooltip: {
    backgroundColor: theme.palette.tooltip.main,
    width: 300,
    maxWidth: 300,
    padding: `${theme.spacing(1, 2)} !important`,
    [theme.breakpoints.up('md')]: {
      width: 530,
      maxWidth: 530
    }
  },
  adminTooltipArrow: {
    color: theme.palette.tooltip.main
  },
  tooltipTitle: {
    fontSize: '.75rem'
  },
  adminTooltipButton: {
    top: '5px !important',
    right: '5px !important',

    '& svg': {
      width: 13,
      height: 13
    }
  },
  tooltipButton: {
    right: '3px !important',
    top: '5px !important'
  },
  tooltipLink: {
    color: theme.palette.primary.main
  },
  addOrganizationAdminContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(2),
      flexDirection: 'row'
    }
  },

  acceptLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '.875rem',
    color: theme.palette.primary.main,
    fontWeight: 600,
    alignSelf: 'flex-start'
  },
  disciplinesTitle: {
    fontWeight: 600,
    textDecoration: 'underline',
    fontSize: '.875rem'
  },
  acceptDisabledLink: {
    textDecoration: 'underline',
    fontSize: '.875rem',
    fontWeight: 600,
    color: '#696969',
    alignSelf: 'flex-start'
  },
  adminContainer: {
    [theme.breakpoints.up('md')]: {
      width: 400
    }
  },

  button: {
    height: 48,
    borderRadius: 8,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
    alignSelf: 'center',
    width: 248,
    '& span': {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: '20px'
    }
  },
  socialContainer: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      width: 400,
      gap: theme.spacing()
    }
  },
  socialTitle: {
    fontWeight: 600,
    fontSize: '1.125rem'
  },
  socialForm: {
    display: 'flex',
    alignItems: 'flex-start',
    minHeight: 40
  },
  socialIcon: {
    '& svg': {
      width: '90% !important'
    }
  },
  socialIconYoutube: {
    '& svg': {
      width: '100% !important'
    }
  },
  checkboxSocial: {
    color: theme.palette.primary.main,
    '&.Mui-checked': {
      color: theme.palette.primary.main
    }
  },
  labelStep: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: 18
  },
  inputSocial: {
    margin: 0,
    '& fieldset': {
      height: 42,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& input': {
      fontWeight: 500
    },
    '&::placeholder': {
      color: theme.palette.primary.main
    }
  },
  instagramIcon: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    width: 23,
    borderRadius: 7,
    padding: 2,
    height: 23,
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(1.5),
    marginRight: theme.spacing(1.5)
  },
  labelContainer: {
    marginBottom: theme.spacing(2)
  },
  blockContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      width: 400
    }
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing()
  },
  link: {
    textDecoration: 'underline',
    fontSize: '.875rem',
    fontWeight: 600,
    cursor: 'pointer'
  },
  combo: {
    '& > div > label': {
      transform: 'translate(14px, 10px) scale(1)'
    },
    '& > div > div': {
      paddingBottom: `0 !important`,
      paddingTop: `0 !important`,
      paddingLeft: `${theme.spacing()}px !important`,
      paddingRight: `${theme.spacing(2)}px !important`
    },
    '& > div > div > div': {
      zIndex: 2
    },
    '& svg': {
      color: theme.palette.primary.main
    }
  },
  comboInput: {
    '& fieldset': {
      backgroundColor: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
      borderRadius: 3,
      minHeight: 45
    },

    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing()
    },
    '& input': {
      zIndex: 1,
      fontWeight: 500
    },
    '& > p': {
      color: theme.palette.secondary.contrastText
    }
  },
  tooltipLinkBlue: {
    color: theme.palette.primary.main
  },
  endButton: {
    zIndex: 1
  },
  altTooltip: {
    backgroundColor: theme.palette.tooltip.main,
    width: 150,
    maxWidth: 150,
    padding: `${theme.spacing(1, 1.5)}px !important`
  },
  whatsAppContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  whatsAppTitle: {
    fontSize: '.875rem',
    flexShrink: 0,
    fontWeight: 600
  },

  imageContainer: {
    width: 50,
    height: 50,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: 50,
    flexShrink: 0
  },
  optionContainer: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    gap: theme.spacing(),
    borderRadius: '50px 0 0 50px',
    '& h6': {
      color: theme.palette.primary.contrastText,
      width: 'calc(100vw - 140px)',
      fontSize: '.875rem',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.up('md')]: {
        width: 270
      }
    },

    '& span': {
      color: theme.palette.secondary.main
    },

    '&.organizer': {
      backgroundColor: theme.palette.secondary.main,

      '& span': {
        color: theme.palette.link.main
      },

      '& h6': {
        color: theme.palette.primary.main,
        fontSize: '.875rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  }
}))
